'use client';

import { forwardRef } from 'react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';
import { TextField, type TextFieldProps } from '@mui/material';

interface CustomCpfFormatProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const CustomCpfFormat = forwardRef<PatternFormatProps, CustomCpfFormatProps>(
  function CpfFormatCustom({ onChange, name, ...other }, ref) {
    return (
      <PatternFormat
        {...other}
        getInputRef={ref}
        onValueChange={values => {
          onChange({
            target: {
              name,
              value: values.value,
            },
          });
        }}
        format="###.###.###-##"
        valueIsNumericString
      />
    );
  }
);

export const CpfTextField = forwardRef<
  HTMLInputElement,
  Omit<TextFieldProps, 'InputProps' | 'inputRef'>
>((props, ref) => {
  return (
    <TextField
      {...props}
      inputRef={ref}
      InputProps={{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        inputComponent: CustomCpfFormat as any,
      }}
    />
  );
});

CpfTextField.displayName = 'CpfTextField';
